import React from 'react';
import _FavoriteProductContent from './_FavoriteProductContent.scss';
import Product from 'components/partials/product';
import {ShowIf} from 'components/utils';
import {connect} from 'react-redux';
import {LoadingPage} from 'components/loading-page';
import {NoContent} from 'components/no-content';
import {toastr} from 'react-redux-toastr';
import {User} from 'api';

class FavoriteProductContent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      isLoading: false
    };
  }

  componentDidMount() {
    this.getList();
  }

  getList() {
    if (this.props.user) {
      this.setState({isLoading: true});
      User.actions.favorites.request({id: this.props.user.id}).then((response) => {
        this.setState({data: response.data, isLoading: false});
      }).catch((error) => {
        this.setState({isLoading: false});
      });
    }
  }

  unFavorite(productId) {
    this.setState({isLoading: true});
    User.actions.unFavorite.request({id: productId}).then(response => {
      this.getList();
      this.setState({isLoading: false});
      toastr.success('Thành công!', 'Đã huỷ yêu thích sản phẩm này.');
    }).catch(() => {
      this.setState({isLoading: false});
    });
  }

  render() {
    const {isLoading} = this.state;
    return (
      <div className="row">
        <LoadingPage isShow={isLoading} />
        <ShowIf condition={this.state.data.length > 0}>
          <div>
            {
              this.state.data.map((item, idx) => {
                return (
                  <div className="favorite-product-box">
                    <div className="box-wrap" key={idx}>
                      <Product enableAddProduct={true} {...item}/>
                      <p className="delete-favorite-product" disabled={isLoading} onClick={this.unFavorite.bind(this, item.id)}>x</p>
                    </div>
                  </div>
                );
              })
            }
          </div>
        </ShowIf>
        <ShowIf condition={!isLoading && this.state.data.length == 0}>
          <NoContent content='Không có sản phẩm, dịch vụ yêu thích nào' height={680}/>
        </ShowIf>
      </div>
    );
  }
}

const mapStateToProp = (state) => {
  return {
    user: state.auth.user
  };
};

export default connect(mapStateToProp)(FavoriteProductContent);



// WEBPACK FOOTER //
// ./components/users/sub-view/favorite-product-content/FavoriteProductContent.jsx